/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicinePatientDetailAliases {
  ACTION_MEDICINE_INACTIVATE = 'action-medicine-inactivate',
  CONTEXTUAL_BAR_MEDICINE_PATIENT_DETAIL = 'contextual-bar-medicine-patient-detail',
  FIELD_CONTINUOUS_MEDICATION = 'field-continuous-medication',
  FIELD_DONT_KNOW_DOSE = 'field-dont-know-dose',
  FIELD_DOSE = 'field-dose',
  FIELD_END_DATE = 'field-end-date',
  FIELD_INTERVAL = 'field-interval',
  FIELD_MEDICINE = 'field-medicine',
  FIELD_NOTES = 'field-notes',
  FIELD_START_DATE = 'field-start-date',
  FIELD_UNIT_MEASUREMENT = 'field-unit-measurement',
  FORM_MEDICINE_PATIENT_DETAIL = 'form-medicine-patient-detail',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  INPUT_5 = 'input-5',
  INPUT_6 = 'input-6',
  LAYOUT_MEDICINE_PATIENT_DETAIL = 'layout-medicine-patient-detail',
  PANEL_MEDICINE_PATIENT_DETAIL = 'panel-medicine-patient-detail',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { MyChartMedicinePatientDetailAliases };
